import React from 'react';
import { Button } from '@archre2/react-core';
import { Icon } from '@archre2/react-core';
import { downloadLogs } from './logs';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.props.tracker.error(error, 'react');
  }

  render() {
    if (this.state.hasError)
      return (
        <div className="container flex-column items-center justify-center bg-white">
          <Icon className="text-white bg-light-grey radius-md margin-b-xl csp-font-size-8rem csp-padding-2rem-4rem">
            times
          </Icon>
          <span className="text-neutral-grey">
            Please download the error logs and send them to the developers
          </span>
          <Button variant="link" className="lowercase" onClick={downloadLogs}>
            download
          </Button>
        </div>
      );

    return this.props.children;
  }
}

export default ErrorBoundary;
